import styled from 'styled-components';

/**
 * A side panel field's label. Its margins are the panel's vertical rhythm: 12px
 * above, 6px to the field (docs/design-system.md § "Panel Fields"). Line height
 * is the type scale's, not a hand-measured 12.1px (PLAT-12137).
 */
export const PROPERTY_CAPTION_MARGIN = '12px 0 6px 0';

export const PropertyCaption = styled.div`
  margin: ${PROPERTY_CAPTION_MARGIN};
  color: var(--text-muted);
  font-weight: var(--font-weight-medium);
  font-size: var(--text-xs);
  line-height: var(--leading-text-xs);
`;
